import { LoadingButton } from '@mui/lab'
import {
    Alert,
    AlertTitle,
    Collapse,
    FormControlLabel,
    FormGroup,
    Switch,
} from '@mui/material'
import qs from 'qs'
import React, { useEffect, useState } from 'react'
import 'react-mde/lib/styles/css/react-mde-all.css'
import Link from '../../../../../components/common/util/input/Link'
import { DropAlert } from '../../../../../components/drops/DropAlert'
import { DropAmountEditor } from '../../../../../components/drops/DropAmountEditor'
import { DropButton } from '../../../../../components/drops/DropButton'
import { DropDetailsEditor } from '../../../../../components/drops/DropDetailsEditor'
import { DropNfthivedropsAuthEditor } from '../../../../../components/drops/DropNfthivedropsAuthEditor'
import { DropPaper } from '../../../../../components/drops/DropPaper'
import { DropPriceEditor } from '../../../../../components/drops/DropPriceEditor'
import { DropStartEndDateEditor } from '../../../../../components/drops/DropStartEndDateEditor'
import { AttributeEditor } from '../../../../../components/drops/pfpeditor/AttributeEditor'
import { CreateDropDialog } from '../../../../../components/drops/pfpeditor/CreateDropDialog'
import { ExternalMinterEditor } from '../../../../../components/drops/pfpeditor/ExternalMinterEditor'
import { NamePatternEditor } from '../../../../../components/drops/pfpeditor/NamePatternEditor'
import { PreviewImageUpload } from '../../../../../components/drops/pfpeditor/PreviewImageUpload'
import { StaticAttributesEditor } from '../../../../../components/drops/pfpeditor/StaticAttributesEditor'
import {
    dropEndDateValid,
    dropStartDateValid,
    getCurrencies,
    isDropAmountInvalid,
    isDropPriceInvalid,
} from '../../../../../components/editor/DropCreatorUtils'
import {
    getAtomicCollection,
    getRamBalance,
    getRamRate,
    isCollectionWhitelistedForPfps,
} from '../../../../../components/helpers/Api'
import { getImage, sleep } from '../../../../../components/helpers/FormatLinks'
import { checkIpfs } from '../../../../../components/helpers/Validators'
import Page from '../../../../../components/page/Page'
import { PFPFeeEditor } from '../../../../../components/pfpfeeeditor/PFPFeeEditor'
import {
    useAtomicCollection,
    useSharedState,
} from '../../../../../components/waxplorer/Waxplorer'
import config from '../../../../../config.json'
import { useTranslation } from 'react-i18next'
import { EditorBreadCrumbs } from '../../../../../components/editor/EditorBreadCrumbs'
import MainButton from '../../../../../components/common/util/input/MainButton'

const DropCreatorPage = (props) => {
    const collectionName = props.collectionName

    const { t } = useTranslation('common')
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const [isUserAuthor, setIsUserAuthor] = useState(null)
    const [isNfthivedropsAuthorized, setIsNfthivedropsAuthorized] =
        useState(null)
    const [isWhitelistedForPfps, setIsWhitelistedForPfps] = useState(null)

    const [dropPriceCurrencyList, setDropPriceCurrencyList] = useState([
        {
            currency: '8,WAX,WAX',
            price: 0,
        },
    ])
    const [payoutRecipients, setPayoutRecipients] = useState(null)
    const [recipientSplits, setRecipientSplits] = useState(null)
    const [dropName, setDropName] = useState('')
    const [dropDescription, setDropDescription] = useState('')
    const [dropStartDateEnabled, setDropStartDateEnabled] = useState(false)
    const [dropStartDate, setDropStartDate] = useState(new Date())
    const [dropEndDateEnabled, setDropEndDateEnabled] = useState(false)
    const [dropEndDate, setDropEndDate] = useState(new Date())
    const [maxClaimable, setMaxClaimable] = useState(0)
    const [waxRam, setWaxRam] = useState(0)
    const [accountLimit, setAccountLimit] = useState(0)
    const [accountLimitCoolDown, setAccountLimitCoolDown] = useState(0)
    const [currencies, setCurrencies] = useState([])
    const [authRequired, setAuthRequired] = useState(false)
    const [ramRate, setRamRate] = useState({ base: 1, quote: 1 })
    const [ramBalance, setRamBalance] = useState(0)

    const [createDropDialogOpened, setCreateDropDialogOpened] = useState(false)

    const ramBytes =
        ramBalance +
        (waxRam
            ? parseInt((waxRam * (ramRate.base / ramRate.quote)) / 1.01)
            : 0)

    const [editorOpen, setEditorOpen] = useState(false)

    const [createSuccess, setCreateSuccess] = useState(null)
    const [transactionId, setTransactionId] = useState(null)

    const [blockRules, setBlockRules] = useState([])
    const [attributes, setAttributes] = useState([])
    const [namePattern, setNamePattern] = useState(null)
    const [previewImage, setPreviewImage] = useState(null)
    const [staticAttributes, setStaticAttributes] = useState([])
    const [useExternalMinter, setUseExternalMinter] = useState(false)

    useEffect(() => {
        getCurrencies(state).then((res) => setCurrencies(res))
        getRamRate(state).then((res) => setRamRate(res))
        getRamBalance(collectionName, state).then((res) => setRamBalance(res))
        isCollectionWhitelistedForPfps(collectionName, state).then((res) =>
            setIsWhitelistedForPfps(res),
        )
    }, [collectionName])

    const handleCreateDrop = () => {
        setCreateDropDialogOpened(true)
    }

    const handleCallBack = (success, transactionId) => {
        setCreateSuccess(success)
        setTransactionId(transactionId)
        fetchDropId(transactionId)
    }

    const [fetchingDropId, setFetchingDropId] = useState(false)
    const [dropId, setDropId] = useState(null)
    const fetchDropId = async (transactionId) => {
        setFetchingDropId(true)
        let actions = []
        let tries = 0
        while (actions.length === 0) {
            await sleep(tries * 1000)
            const response = await fetch(
                (process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                    ? config.hyperiontest
                    : config.hyperion) +
                    `/v2/history/get_transaction?id=${transactionId}`,
            )
            const json = await response.json()
            actions = json.actions !== undefined ? json.actions : []
            tries++
        }
        for (const action of actions) {
            if (action.act.name === 'lognewpfp') {
                setDropId(action.act.data.drop_id)
                break
            }
        }
        setFetchingDropId(false)
    }

    const parseCollectionDetails = (res) => {
        if (res?.success) {
            setIsUserAuthor(res.data.author === userName)
            setIsNfthivedropsAuthorized(
                res.data.authorized_accounts.includes('nfthivedrops'),
            )
        }
    }

    useEffect(() => {
        if (userName) {
            getAtomicCollection(collectionName).then(parseCollectionDetails)
        }
        setPayoutRecipients(
            payoutRecipients
                ? payoutRecipients
                : userName !== null
                ? [userName]
                : null,
        )
        setRecipientSplits(recipientSplits ? recipientSplits : [1])
    }, [userName])

    const hasStaticAttributeErrors = () => {
        for (const attribute of staticAttributes) {
            if (
                attribute.name.length === 0 ||
                attribute.value.length === 0 ||
                ((attribute.type === 'uint64' || attribute.type === 'double') &&
                    isNaN(attribute.value)) ||
                ((attribute.type === 'ipfs' || attribute.type === 'image') &&
                    !checkIpfs(attribute.value))
            ) {
                return true
            }
        }
        return false
    }

    const hasInconsistentResolutions = () => {
        let width, height
        for (const attribute of attributes) {
            for (const possibleValue of attribute.possible_values) {
                for (const layer of possibleValue.layers) {
                    if (!width) {
                        width = layer.width
                    }
                    if (!height) {
                        height = layer.height
                    }
                    if (
                        layer.width &&
                        layer.height &&
                        (width !== layer.width || height !== layer.height)
                    ) {
                        return (
                            <div>
                                Attribute{' '}
                                <span className="text-primary font-bold">
                                    {attribute.attribute_name}
                                </span>{' '}
                                - Value{' '}
                                <span className="text-primary font-bold">
                                    {possibleValue.value}
                                </span>{' '}
                                (layer{' '}
                                <span className="text-primary font-bold">
                                    {layer.layer}
                                </span>
                                ) has a different resolution (
                                <span className="text-primary font-bold">
                                    {layer.width}x{layer.height}
                                </span>
                                ) than the rest of the layers! While it may not
                                look wrong in the preview window above, minting
                                the NFTs can produce unpredictable results.
                                Please make sure all images have the same size!
                            </div>
                        )
                    }
                }
            }
        }
        return null
    }

    const image = getImage('')

    const collectionNameData = useAtomicCollection(collectionName)

    return (
        <Page
            id="PfpDropCreatorNewPage"
            image={image}
            banners={false}
            {...props}
        >
            <EditorBreadCrumbs
                collectionUniqueName={
                    collectionNameData?.collection_name
                        ? collectionNameData.collection_name
                        : collectionName
                }
                collectionDisplayName={
                    collectionNameData?.name
                        ? collectionNameData.name
                        : collectionName
                }
                path={'dropcreator'}
                pathDisplayName={t('editor.manage_drops')}
                createNew={'newpfp'}
                newDisplay={t('editor.new_pfp')}
            />
            <CreateDropDialog
                collectionName={collectionName}
                createDropDialogOpened={createDropDialogOpened}
                setCreateDropDialogOpened={setCreateDropDialogOpened}
                attributes={attributes}
                blockRules={blockRules}
                namePattern={namePattern}
                staticAttributes={staticAttributes}
                maxClaimable={maxClaimable}
                accountLimit={accountLimit}
                accountLimitCoolDown={accountLimitCoolDown}
                dropName={dropName}
                dropDescription={dropDescription}
                dropStartDate={dropStartDate}
                dropStartDateEnabled={dropStartDateEnabled}
                dropEndDate={dropEndDate}
                dropEndDateEnabled={dropEndDateEnabled}
                dropPriceCurrencyList={dropPriceCurrencyList}
                payoutRecipients={payoutRecipients}
                recipientSplits={recipientSplits}
                authRequired={authRequired}
                waxRam={waxRam}
                useExternalMinter={useExternalMinter}
                previewImage={previewImage}
                handleCallBack={handleCallBack}
            />
            <div className="text-5xl mx-5">Drop Creator</div>
            <DropAlert
                closable
                title="New Tutorial!"
                severity="info"
                autoVerticalMargin={false}
                className="mt-10 mx-5"
            >
                {t('drops.confused_article')} Check it out{' '}
                <a
                    target="_blank"
                    href="https://hivebp.medium.com/sell-nfts-directly-with-basic-drops-116d6e9450a2"
                    className="underline"
                >
                    by clicking here
                </a>
            </DropAlert>
            <DropAlert
                closable
                title="Creating PFPs on Testnet"
                severity="warning"
                autoVerticalMargin={false}
                className="mt-10 mx-5"
            >
                {t('drops.recommended_to_try_creating_pfps_on_testnet_first')}
                <a
                    target="_blank"
                    href="https://test.nfthive.io"
                    className="underline block"
                >
                    https://test.nfthive.io
                </a>
            </DropAlert>
            <div className="mx-2 md:mx-5">
                <div className="flex justify-center my-10">
                    <div className="my-auto text-2xl mb-5">
                        {t(
                            'drops.create_a_drop_with_assets_from_your_collection',
                        )}
                    </div>
                </div>

                <div>
                    <DropNfthivedropsAuthEditor
                        isUserAuthor={isUserAuthor}
                        isNfthivedropsAuthorized={isNfthivedropsAuthorized}
                        collectionName={collectionName}
                        setIsNfthivedropsAuthorized={
                            setIsNfthivedropsAuthorized
                        }
                    />
                    <DropAlert
                        condition={isWhitelistedForPfps === true}
                        severity="success"
                    >
                        {t('drops.this_collection_is_whitelisted_for_pfps')}
                    </DropAlert>
                    <DropAlert
                        condition={isWhitelistedForPfps === false}
                        severity="warning"
                        title={t('drops.minimum_fee_required')}
                    >
                        {t('drops.pfp_fee_explanation')}
                    </DropAlert>
                    {!isWhitelistedForPfps ? (
                        <PFPFeeEditor collectionName={collectionName} />
                    ) : (
                        ''
                    )}

                    <AttributeEditor
                        attributes={attributes}
                        setAttributes={setAttributes}
                        blockRules={blockRules}
                        setBlockRules={setBlockRules}
                        hasInconsistentResolutions={hasInconsistentResolutions}
                    />
                    <PreviewImageUpload
                        previewImage={previewImage}
                        setPreviewImage={setPreviewImage}
                    />
                    <NamePatternEditor
                        namePattern={namePattern}
                        setNamePattern={setNamePattern}
                    />
                    <StaticAttributesEditor
                        staticAttributes={staticAttributes}
                        setStaticAttributes={setStaticAttributes}
                        hasStaticAttributeErrors={hasStaticAttributeErrors}
                    />
                    <DropAmountEditor
                        maxClaimable={maxClaimable}
                        setMaxClaimable={setMaxClaimable}
                        accountLimit={accountLimit}
                        setAccountLimit={setAccountLimit}
                        accountLimitCoolDown={accountLimitCoolDown}
                        setAccountLimitCoolDown={setAccountLimitCoolDown}
                        ramToBuyInWax={waxRam}
                        extraRamBytesAfterRamBought={ramBytes}
                        setRamToBuyInWax={setWaxRam}
                        mustBeFinite={true}
                        isPfp={true}
                    />
                    <DropDetailsEditor
                        dropName={dropName}
                        setDropName={setDropName}
                        editorOpen={editorOpen}
                        setEditorOpen={setEditorOpen}
                        dropDescription={dropDescription}
                        setDropDescription={setDropDescription}
                        title={t('drops.drop_details')}
                        nameTitle={t('drops.drop_name')}
                        descriptionTitle={t('drops.drop_description')}
                    />
                    <DropStartEndDateEditor
                        dropStartDate={dropStartDate}
                        setDropStartDate={setDropStartDate}
                        dropStartDateEnabled={dropStartDateEnabled}
                        setDropStartDateEnabled={setDropStartDateEnabled}
                        dropEndDate={dropEndDate}
                        setDropEndDate={setDropEndDate}
                        dropEndDateEnabled={dropEndDateEnabled}
                        setDropEndDateEnabled={setDropEndDateEnabled}
                    />
                    <DropPriceEditor
                        dropId={dropId}
                        dropPriceCurrencyList={dropPriceCurrencyList}
                        setDropPriceCurrencyList={setDropPriceCurrencyList}
                        payoutRecipients={payoutRecipients}
                        setPayoutRecipients={setPayoutRecipients}
                        currencies={currencies}
                        recipientSplits={recipientSplits}
                        setRecipientSplits={setRecipientSplits}
                    />
                    <DropPaper>
                        <div>
                            <div className="text-2xl mb-5">
                                {t('drops.restrict_drop_to_specific_accounts')}
                            </div>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={authRequired}
                                            onChange={() => {
                                                setAuthRequired(!authRequired)
                                            }}
                                        />
                                    }
                                    label={t('drops.restrict_drops')}
                                />
                            </FormGroup>
                            <div className="my-5">
                                {t('drops.edit_restrictions')}
                            </div>

                            <Collapse in={authRequired}>
                                <Alert severity="warning">
                                    <AlertTitle>
                                        {t('alerts.caution')}
                                    </AlertTitle>
                                    {t(
                                        'drops.make_sure_to_edit_restrictions_once_drop_created',
                                    )}
                                </Alert>
                            </Collapse>
                        </div>
                    </DropPaper>

                    <ExternalMinterEditor
                        useExternalMinter={useExternalMinter}
                        setUseExternalMinter={setUseExternalMinter}
                    />

                    <DropPaper>
                        <DropAlert
                            condition={attributes.length === 0}
                            severity={'error'}
                            elementId={'LayerEditor'}
                        >
                            {t('drops.layers_undefined')}
                        </DropAlert>

                        <DropAlert
                            condition={!checkIpfs(previewImage)}
                            severity={'error'}
                            elementId={'PreviewImageUpload'}
                        >
                            {t('drops.valid_ipfs_hash_is_required')}
                        </DropAlert>

                        <DropAlert
                            condition={
                                namePattern === null || namePattern.length === 0
                            }
                            severity={'error'}
                            elementId={'NamePatternEditor'}
                        >
                            {t('drops.no_name_pattern_yet')}
                        </DropAlert>

                        <DropAlert
                            condition={hasStaticAttributeErrors()}
                            severity="error"
                            elementId={'StaticAttributesEditor'}
                        >
                            {t('drops.at_least_one_static_attribute_error')}
                        </DropAlert>

                        <DropAlert
                            condition={
                                !createSuccess && parseInt(maxClaimable) === 0
                            }
                            severity={'warning'}
                            elementId={'DropAmountEditor'}
                        >
                            {t('drops.ram_warning')}
                        </DropAlert>

                        <DropAlert
                            condition={dropName.length === 0}
                            severity={'error'}
                            elementId={'DropDetailsEditor'}
                        >
                            {t('drops.drop_name_is_missing')}
                        </DropAlert>

                        <DropAlert
                            condition={
                                !createSuccess &&
                                !editorOpen &&
                                !dropDescription
                            }
                            severity="warning"
                            elementId={'DropDetailsEditor'}
                        >
                            {t('drops.description_recommended')}
                        </DropAlert>

                        <DropAlert
                            condition={isDropAmountInvalid({
                                maxClaimable,
                                accountLimit,
                                accountLimitCoolDown,
                                waxRam,
                                ramBytes,
                                mustBeFinite: true,
                                isPfp: true,
                            })}
                            severity="error"
                            elementId="DropAmountEditor"
                        >
                            {isDropAmountInvalid({
                                maxClaimable,
                                accountLimit,
                                accountLimitCoolDown,
                                waxRam,
                                ramBytes,
                                mustBeFinite: true,
                                isPfp: true,
                            })}
                        </DropAlert>

                        <DropAlert
                            condition={
                                !dropStartDateValid(
                                    dropStartDateEnabled,
                                    dropStartDate,
                                )
                            }
                            severity={'error'}
                            elementId={'DropStartEndDateEditor'}
                        >
                            {t('drops.drop_start_date_invalid')}
                        </DropAlert>

                        <DropAlert
                            condition={
                                !dropEndDateValid(
                                    dropEndDateEnabled,
                                    dropStartDateEnabled,
                                    dropStartDate,
                                    dropEndDate,
                                )
                            }
                            severity={'error'}
                            elementId={'DropStartEndDateEditor'}
                        >
                            {t('drops.drop_end_date_invalid')}
                        </DropAlert>

                        <DropAlert
                            condition={isDropPriceInvalid(
                                dropPriceCurrencyList,
                                payoutRecipients,
                            )}
                            severity={'error'}
                            elementId={'DropPriceEditor'}
                        >
                            {isDropPriceInvalid(
                                dropPriceCurrencyList,
                                payoutRecipients,
                            )}
                        </DropAlert>
                        <DropAlert
                            condition={hasInconsistentResolutions()}
                            severity={'error'}
                            elementId={'AttributeEditor'}
                        >
                            {hasInconsistentResolutions()}
                        </DropAlert>
                        <DropAlert
                            condition={isWhitelistedForPfps === false}
                            severity="warning"
                            title={t('drops.minimum_fee_required')}
                        >
                            {t('drops.pfp_fee_explanation')}
                        </DropAlert>

                        <Collapse in={!createSuccess}>
                            <div className="flex justify-center my-5">
                                <div className="mx-2 md:mx-5">
                                    <MainButton
                                        onClick={handleCreateDrop}
                                        isDisabled={
                                            createSuccess ||
                                            dropName.length === 0 ||
                                            !isNfthivedropsAuthorized ||
                                            !checkIpfs(previewImage) ||
                                            !dropStartDateValid(
                                                dropStartDateEnabled,
                                                dropStartDate,
                                            ) ||
                                            !dropEndDateValid(
                                                dropEndDateEnabled,
                                                dropStartDateEnabled,
                                                dropStartDate,
                                                dropEndDate,
                                            ) ||
                                            isDropAmountInvalid({
                                                maxClaimable,
                                                accountLimit,
                                                accountLimitCoolDown,
                                                waxRam,
                                                ramBytes,
                                                isPfp: true,
                                            }) ||
                                            isDropPriceInvalid(
                                                dropPriceCurrencyList,
                                                payoutRecipients,
                                            ) ||
                                            attributes.length === 0 ||
                                            namePattern === null ||
                                            namePattern.length === 0 ||
                                            hasStaticAttributeErrors() ||
                                            hasInconsistentResolutions()
                                        }
                                    >
                                        {' '}
                                        Create Drop
                                    </MainButton>
                                </div>

                                <MainButton
                                    //as="a"
                                    className="mx-2 md:mx-5"
                                    href={`/creator/${collectionName}/dropcreator`}
                                    color="danger"
                                >
                                    {' '}
                                    Back to Overview
                                </MainButton>
                            </div>
                        </Collapse>
                        <Collapse in={createSuccess && transactionId}>
                            <div className="flex justify-center">
                                <div className="w-full lg:w-2/3">
                                    <DropAlert
                                        severity={'success'}
                                        transactionId={transactionId}
                                        condition={transactionId !== null}
                                    />
                                    <div className="flex justify-evenly w-full">
                                        <DropButton
                                            className="w-1/3 px-1"
                                            fullWidth
                                            href={
                                                (process.env
                                                    .NEXT_PUBLIC_TESTNET ===
                                                'TRUE'
                                                    ? 'https://testnet.waxblock.io/transaction/'
                                                    : 'https://waxblock.io/transaction/') +
                                                transactionId
                                            }
                                            external
                                        >
                                            View on waxblock.io
                                        </DropButton>
                                        <div className="w-1/3 px-1">
                                            <LoadingButton
                                                fullWidth
                                                variant="outlined"
                                                disabled={fetchingDropId}
                                                loading={fetchingDropId}
                                            >
                                                <Link href={`/drop/${dropId}`}>
                                                    View Drop
                                                </Link>
                                            </LoadingButton>
                                        </div>
                                        <DropButton
                                            className="w-1/3 px-1"
                                            fullWidth
                                            href={`/creator/${collectionName}/dropcreator`}
                                            color="error"
                                        >
                                            Back to Overview
                                        </DropButton>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </DropPaper>
                </div>
            </div>
        </Page>
    )
}

DropCreatorPage.getInitialProps = async (ctx) => {
    const c = ctx.query.collection
    const paths = ctx.asPath.split('/')
    const values = qs.parse(paths[paths.length - 1].replace(c + '?', ''))
    values['collectionName'] = c
    return values
}

export default DropCreatorPage
